import Vue from 'vue'
import router from '@/router/index'
import {
  login,
  getInfo,
  logout,
  getRoutes,
  getGroupBalance,
  getReg,
  setReferer,
  getSystemNoticePolling,
  getCollectNum
} from '@/api/login'
import { getCart } from '@/api/cart'
import { getCapacity } from '@/api/main'
import { createRouters } from '@/utils/util'
import { ACCESS_TOKEN, ACCESS_AGREEMENT, RECOMMENDED_SOURCES } from '@/store/mutation-types'
import { exchangeRate, getUSDRate } from '@/api/products'
// import md5 from 'js-md5'

const user = {
  state: {
    token: '',
    info: {},
    hotWords: [],
    exception: {},
    balance: '0.00',
    routers: [],
    cartTotal: 0,
    searchSource: 2,
    agreement: false,
    parentIdMap: [],
    groupData: {},
    affToken: '',
    accountType: 0,
    curList: [],
    cur: 'USD',
    rate: 1.0,
    systemNoticePolling: {},
    favoritesNum: 0
  },

  getters: {
    getAgreement: state => {
      if (Vue.ls.get(ACCESS_AGREEMENT)) {
        state.agreement = Vue.ls.get(ACCESS_AGREEMENT)
        return state.agreement
      } else {
        return state.agreement
      }
    },
    getToken: state => {
      if (Vue.ls.get(ACCESS_TOKEN)) {
        state.token = Vue.ls.get(ACCESS_TOKEN)
        return state.token
      } else {
        return state.token
      }
    },
    getSearchSource: state => {
      return state.searchSource
    },
    getException: state => {
      return state.exception
    },
    getHotWords: state => {
      return state.hotWords
    },
    userRouters: state =>
      state.routers
        .filter(item => item.name === 'setting')[0]
        .children.filter(item => item.meta.title === '账户信息')[0].children,
    cartTotal: state => state.cartTotal,
    rightMenu: state => {
      return state.routers.filter(item => item.name === 'setting')[0].children.filter(item => item.meta.show)
    },
    getAffToken: state => {
      return state.affToken
    },
    getCurList: state => {
      return state.curList
    },
    getCur: state => {
      return state.cur
    },
    getRate: state => {
      return state.rate
    },
    systemNoticePolling: state => {
      return state.systemNoticePolling
    }
  },

  mutations: {
    SET_SEARCH_SOURCE: (state, arr) => {
      state.searchSource = arr
    },
    SET_HOT_WORDS: (state, n) => {
      state.hotWords = n
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_AGREEMENT: (state, agreement) => {
      state.agreement = agreement
      Vue.ls.set(ACCESS_AGREEMENT, agreement)
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    },
    SET_EXCEPTION: (state, exception) => {
      state.exception = exception
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
    },
    SET_CART_TOTAL: (state, cartTotal) => {
      state.cartTotal = cartTotal
    },
    SET_PARENT_ID_MAP: (state, data) => {
      state.parentIdMap = data
    },
    SET_GROUP_DATA: (state, data) => {
      state.groupData = data
    },
    SET_AFF_TOKEN: (state, data) => {
      state.affToken = data
    },
    SET_ACCOUNT_TYPE: (state, data) => {
      state.accountType = data
    },
    SET_CUR_LIST: (state, data) => {
      state.curList = data
    },
    SET_CUR: (state, data) => {
      state.cur = data
    },
    SET_RATE: (state, data) => {
      state.rate = data
    },
    SET_SYSTEM_NOTICE_POLLING: (state, data) => {
      state.systemNoticePolling = data
    },
    SET_FAVORITES_NUM: (state, data) => {
      state.favoritesNum = data
    }
  },
  actions: {
    getGroup({ commit }) {
      return new Promise((resolve, reject) => {
        getCapacity()
          .then(response => {
            commit('SET_GROUP_DATA', response.data || {})
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取购物车数据
    getCartData({ commit }) {
      return new Promise((resolve, reject) => {
        getCart()
          .then(response => {
            const result = response.data
            commit('SET_CART_TOTAL', result.total_item_num || 0)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取系统公告
    GetSystemNoticePolling({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 防止重复请求：如果已有数据或正在请求中，直接返回
        if (state.systemNoticePolling) {
          resolve({ data: state.systemNoticePolling })
          return
        }
        getSystemNoticePolling()
          .then(response => {
            const result = response.data
            commit('SET_SYSTEM_NOTICE_POLLING', result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            const result = response.data
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_ACCOUNT_TYPE', 0)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 注册
    GetReg({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getReg(userInfo)
          .then(response => {
            const result = response.data
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户余额
    getBalance({ commit }) {
      return new Promise((resolve, reject) => {
        getGroupBalance()
          .then(response => {
            const result = response.data
            commit('SET_BALANCE', result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo({ account_type: this.state.accountType })
          .then(response => {
            const result = response.data
            commit('SET_INFO', result)
            setTimeout(() => {
              if (window.ssq) {
                window.ssq.push('setLoginInfo', {
                  user_id: result.id, // 必填，加密后的用户 id
                  user_name: result.username ? result.username : result.email, // 必填，用户名
                  email: result.email, // 邮箱
                  description: 'Printdoors Customer' // 描述
                })
              }
            }, 1000)
            if (result.referer === 'null') {
              setReferer({ referer: Vue.ls.get(RECOMMENDED_SOURCES) })
            }
            resolve(response)
          })
          .catch(() => {
            this.dispatch('Logout')
          })
      })
    },
    // 获取路由
    GetRouters({ commit }) {
      // eslint-disable-next-line no-return-await
      return new Promise((resolve, reject) => {
        getRoutes()
          .then(response => {
            const filterRouters = createRouters(response.data)
            commit(
              'SET_PARENT_ID_MAP',
              response.data.map(item => ({
                id: item.id,
                name: item.name
              }))
            )
            commit('SET_ROUTERS', filterRouters)
            resolve(filterRouters)
          })
          .catch(() => {
            // this.dispatch('Logout')
          })
      })
    },
    // 登出
    Logout({ commit }) {
      return new Promise(resolve => {
        logout()
          .then(() => {
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_INFO', {})
            // commit('SET_ROLES', [])
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove(ACCESS_AGREEMENT)
            Vue.ls.remove('cur')
            Vue.ls.remove('rate')
            window.ssq.push('clearUser')
            router.push('/home')
            // location.reload()
          })
      })
    },
    // 获取币种列表
    GetCurList({ commit }) {
      return new Promise((resolve, reject) => {
        exchangeRate()
          .then(response => {
            const result = []
            response.data.forEach(item => {
              result.push({
                label: item[1],
                value: item[0]
              })
            })
            commit('SET_CUR_LIST', result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取汇率
    GetRate({ commit }) {
      return new Promise((resolve, reject) => {
        getUSDRate({ targetCurrency: this.state.user.cur })
          .then(response => {
            Vue.ls.set('rate', this.state.user.cur === 'USD' ? 1.0 : response.data)
            commit('SET_RATE', this.state.user.cur === 'USD' ? 1.0 : response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetFavoritesNum({ commit }) {
      if (!Vue.ls.get(ACCESS_TOKEN)) {
        return
      }
      return new Promise((resolve, reject) => {
        getCollectNum({}).then(response => {
          commit('SET_FAVORITES_NUM', response.data.total_collect_num || 0)
          resolve(response)
        })
      })
    }
  }
}

export default user
